/**
 * Checks if the device has touch capabilities.
 *
 * @since ??
 *
 * @returns {boolean} True if the device has touch capabilities, false otherwise.
 */
export const isTouchDevice = (): boolean =>
  ('ontouchstart' in window && 'function' === typeof window.ontouchstart) || (navigator?.maxTouchPoints ?? 0) > 0;
